import React from 'react';
const IconActionEmail = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 20H22V4H2V8.58L12 14.35L20 9.73V18H4V12L2 10.89V20ZM4 7.42V6H20V7.42L12 12L4 7.42Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconActionEmail;